// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__2qqt6","label":"Category_label__3A9IX","content":"Category_content__mbsFl","header":"Category_header__Dznn_","location":"Category_location__leedO"};